import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../app/store';
import { NotConfigured } from './NotConfigured';
import { fetchStaffMe } from './slice';

type Props = {
  children: ReactNode;
  splash?: ReactNode;
};

// Mission Control's boot gate — the staff-registry sibling of the analytics
// platform's ClientsProvider. Once authenticated it fetches /api/v1/cfo/me;
// a 403 renders the Not-Configured screen (valid platform login, no
// staff_profile row) instead of the app.
export function StaffProvider({ children, splash = null }: Props) {
  const dispatch = useAppDispatch();
  const userAuthenticated = useAppSelector((s) => s.app.userAuthenticated);
  const { loaded, notConfigured, error } = useAppSelector((s) => s.staff);

  useEffect(() => {
    if (userAuthenticated && !loaded) {
      void dispatch(fetchStaffMe());
    }
  }, [dispatch, userAuthenticated, loaded]);

  if (!userAuthenticated || !loaded) return <>{splash}</>;
  if (notConfigured) return <NotConfigured />;
  if (error) {
    return <NotConfigured error onRetry={() => void dispatch(fetchStaffMe())} />;
  }
  return <>{children}</>;
}
